import { useEffect, type PropsWithChildren, type ReactNode } from 'react';
import Portal from '../../Portal';

export interface ModalProps extends PropsWithChildren {
  title?: string;
  bottom?: ReactNode;
  onClose: () => void;
}

const Modal = ({ title, children, bottom, onClose }: ModalProps) => {
  const handleClickDimmer = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  return (
    <Portal>
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60" onClick={handleClickDimmer}>
        <div className="flex flex-col mx-6 w-full bg-white rounded-xl shadow-modal break-words">
          {title && <h1 className="px-6 py-4 w-full h-14 border-b border-gray-200 text-center font-bold">{title}</h1>}
          <div className="flex-grow flex flex-col items-center p-6">{children}</div>
          {bottom && <div className="mx-6 mb-6">{bottom}</div>}
        </div>
      </div>
    </Portal>
  );
};

export default Modal;
